import App from "../../main";

//SDK //API
declare const gamezop: any;

const apiKey: string = "57d370d9-d604-4b6b-8628-95ee800b2386";
const gameCode: string = "wIRrQjVa7";

export type GAMEZOP_PLAYER_DATA = {
    firstName: string
    gzpId: string,
    isClient: boolean,
    lastName: string,
    loginModes: any[],
    phone: string,
    photo: string
};

export type GAMEZOP_INIT_DATA = {
    matchId: string,
    players: GAMEZOP_PLAYER_DATA[],
    gameConfig: string
};

export enum GAMEZOP_STATE {
    LOADED = "loaded",
    PLAYING = "playing",
    LEVEL_UP = "levelup",
    PAUSED = "paused",
    OVER = "over",
    CONTINUE = "continue",
    META_UPDATE = "meta-update"
}


export interface GamezopGame {

    /**
    * mute your game.
    */
    mute(): void;

    /**
    * unmute your game
    */
    unmute(): void;

    /**
    * Applies to games which have a server of their own. 
    * When Gamezop calls this, your game should disconnect 
    * from the game server and be ready for a new game to start.
    */
    gameReady(): any;

    /**
     * When this is called, the game should start with
     *  the data passed in the function call.
     * @param initData 
     */
    gameInit(initData: GAMEZOP_INIT_DATA): void;

    /**
     * callback to the game's end game function. 
     * Calling this method should directly end 
     * the game and take the user to the game over screen.
     */
    gameEnd(): void;

    /**
     * Used in case of asynchronous multiplayer games.
     *  When called, the game should return a game config 
     * with which it wants to be initialised. 
     */
    getGameConfig(): string;

    /**
     * When this method is called, the game should restart. 
     * It's the same function you would call when a user is
     *  on a game-over screen and taps on the retry button. 
     */
    gameContinue(): any;
};


export class GameZopSDK {
    
    public isSDKLoaded: boolean = null;

    public store = new Map<string, number>();
    public movers = new Map<string, number>();

    public tCount = 0;
    public kCount = 0;

    public gamezop = gamezop;

    private gzpGame : GamezopGame = null as any;

    public initializeSDK() {
        var self = this;

        if (apiKey == "" || gameCode == "") {
            return;
        }
        gamezop.Initialize({
            apiKey: apiKey,
            gameCode: gameCode,
            debug: true,
            play: function () {
                console.log("Play Function");
                window.game.scene.getScene("game").events.emit("onSdkResume");
            },
            pause: function () {
                console.log("Pause Function");
                window.game.scene.getScene("game").events.emit("onSdkPause");
            },
            mute: function () {
                console.log("Mute Function");
                if(self.gzpGame == null) return;
                self.gzpGame.mute();
            },
            unmute: function () {
                console.log("UnMute Function");
                if(self.gzpGame == null) return;
                self.gzpGame.unmute();
            },
            gameReady: function () {
                console.log("GameReady Function");
                if(self.gzpGame == null) return;
                self.gzpGame.gameReady();
            },
            gameInit: function (initData) {
                console.log("GameInit Function");
                self.tCount = self.kCount = 0;
                if(self.gzpGame == null) return;
                self.gzpGame.gameInit(initData);
            },
            gameEnd: function () {
                console.log("GameEnd Function");
                if(self.gzpGame == null) return;
                return self.gzpGame.gameEnd();
            },
            getGameConfig: function () {
                console.log("GetGameConfig Function");
                if(self.gzpGame == null) return;
                return self.gzpGame.getGameConfig();
            },
            gameContinue: function () {
                console.log("GameContinue Function");
                if(self.gzpGame == null) return;
                return self.gzpGame.gameContinue();
            },
        }).then(function () {
            console.log("SDK Loaded successfully");
            self.isSDKLoaded = true;
        }).catch(function (e) {
            self.isSDKLoaded = false;
            console.log("SDK initialize error:", e)
        });
    }
    
    public getMetadata(): any {
        console.log("Get gameZop Meta Data", gamezop.data.metadata);
        return gamezop.data.metadata;
    }

    public setGameStateLoaded(){
        let currentFPS: string = Math.floor(window.game.loop.actualFps).toString();
        gamezop.setState({
            state: GAMEZOP_STATE.LOADED,
            afps : currentFPS
        });
        console.log("Set Loaded State");
    }

    public setGameState(gameState: GAMEZOP_STATE, currentScore: number, _highScore:number) {
        let currentFPS: string = Math.floor(window.game.loop.actualFps).toString();
        gamezop.setState({
            state: gameState,
            score: currentScore,
            tcount : this.tCount,
            kcount : this.kCount,
            metadata: {
                highscore: _highScore,
            },
            afps : currentFPS
        });
        console.log("Current State",gameState);
        // console.log("Highscore",_highScore);
    }

    public updateLoading(loadingPercentage: number) {
        window.postMessage({
            type: 'loading',
            gameCode: gameCode,
            progress: loadingPercentage,
        }, '*');
        if (window.parent !== window) {
            window.parent.postMessage({
                type: 'loading',
                gameCode: gameCode,
                progress: loadingPercentage,
            }, '*');
        }
    }


     /**
     * isKia : Is keyboard Input allowed?
     * Use this to know if keyboard input
     * should be allowed or not. 
     * @returns 
     */
    public isKia(): boolean {
        //console.log("KeyboardInput",gamezop.isKia);
        return gamezop.isKia;
    }

    /**
     * use this to know if you should enable/disable the sound
     * in the start of the game
     * @returns 
     */
    public isSoundEnabled(): boolean {
        return gamezop.isSoundEnabled;
    }

    /**
     * use this to know if its a battle game or not
     * @returns 
     */
    public isBattleGame(): boolean {
        //console.log("isBattleGame",gamezop.isBattleGame());
        // return true;
        return gamezop.isBattleGame();
    }

    /**
    * use this to know if the game is being played in Tournament or not.
    * @returns tournament specific data
    */
    public getContestDetails(): any {
        return gamezop.getContestDetails();
    }

    public isTournament() {
        let details = this.getContestDetails();
        return Object.keys(details).length != 0;
    }
    /**/

    public setGame(game: GamezopGame) {
        this.gzpGame = game;
    }

    public onKeyInput() {
        this.kCount++;
    }

    public onTouchInput() {
        this.tCount++;
    }

    public onGameReset() {
        this.kCount = this.tCount = 0;
    }

    public getHighscore():number {
        return gamezop.data.metadata.highscore;
    }

    public showAd(callback : any){
        gamezop.showAd({type: "nonskipvideo"}, callback);
    }

    public gameMuted(value: boolean) {
        gamezop.gameMuted = value;
        // console.log("Gamezop - Game Muted:", gamezop.gameMuted);
    }
}